import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import {
  useGetFieldsGroupsQuery,
} from 'services/api/Meteorology/Fields/TrackingForecast/Register';

export default function useGroups() {
  const { data, error } = useGetFieldsGroupsQuery();

  useHandleRequestErrors(error as unknown as ResponseError);

  return { groups: data };
}
